import { commercialBase } from "./tokens/commercialBase";
import { molten } from "./tokens/moltenCopper";
import { electrician } from "./tokens/electrician";
import { remembrance } from "./tokens/remembrance";
import { growth } from "./tokens/growth";
import { executiveCommercial } from "./tokens/executiveCommercial";
import { validateTheme } from "./validateTheme";

// Validate all themes at module load — fail fast if schema broken
const allThemes = [
  commercialBase,
  molten,
  electrician,
  remembrance,
  growth,
  executiveCommercial,
];

allThemes.forEach(validateTheme);

export const THEME_REGISTRY = {
  molten,
  "executive-commercial": executiveCommercial,
  electrician,
  remembrance,
  growth,
};

const THEME_ALIASES = {
  moltenCopper: "molten",
  executive_commercial: "executive-commercial",
  commercialBase: "executive-commercial",
  commercial: "executive-commercial",
};

export function getTheme(themeId) {
  const normalized = THEME_ALIASES[themeId] ?? themeId;
  const theme = THEME_REGISTRY[normalized];
  if (!theme) {
    throw new Error(`Unknown theme "${themeId}". No fallback allowed.`);
  }
  return theme;
}
